import Keycloak from "keycloak-js"
import { getEnv } from "../util/environment"
import { IUser } from "../interfaces/user/IUser"

const KEYCLOAK_URL = getEnv("VITE_APP_KEYCLOAK_URL")
const KEYCLOAK_CLIENT_ID = getEnv("VITE_APP_KEYCLOAK_CLIENT_ID")
const DEFAULT_KEYCLOAK_REALM = getEnv("VITE_APP_DEFAULT_KEYCLOAK_REALM")

const keycloakConfig: Keycloak.KeycloakConfig = {
  url: KEYCLOAK_URL as string,
  realm: DEFAULT_KEYCLOAK_REALM as string,
  clientId: KEYCLOAK_CLIENT_ID as string
}
const KC = new Keycloak(keycloakConfig)

const doLogin = KC.login.bind(KC)

const doLogout = () => KC.logout()

const getToken = () => KC.token

const getParsedToken = () => KC.tokenParsed

const getUsername = () => KC.tokenParsed?.preferred_username

const getGivenName = () => KC.tokenParsed?.given_name

const getName = () => KC.tokenParsed?.name

const getEmail = () => KC.tokenParsed?.email

const getCompany = () => KC.tokenParsed?.organisation

const getBpn = () => KC.tokenParsed?.bpn

const getTenant = () => KC.tokenParsed?.tenant

const hasRole = (roles: string[]) => roles.some((role: string) => KC.hasRealmRole(role))

const isLoggedIn = () => !!KC.token

const hasValidResource = () =>
  KC.tokenParsed?.resource_access?.hasOwnProperty(keycloakConfig.clientId)

const getLoggedUser = (): IUser => ({
  userName: getUsername(),
  name: getName(),
  givenName: getGivenName(),
  email: getEmail(),
  company: getCompany(),
  bpn: getBpn(),
  tenant: getTenant()
})

const update = () => {
  KC.updateToken(600)
    .then((refreshed: boolean) => {
      console.log(`${getUsername()} token refreshed ${refreshed}`)
    })
    .catch(() => {
      console.log(`${getUsername()} token refresh failed`)
    })
}

const initKeycloak = (onAuthenticatedCallback: () => void | Promise<void>) => {
  KC.init({
    onLoad: "login-required",
    pkceMethod: "S256",
    checkLoginIframe: false
  })
    .then(async (authenticated: boolean) => {
      if (authenticated) {
        console.log(`${getUsername()} authenticated`)
        await onAuthenticatedCallback()
      } else {
        console.log(`${getUsername()} authentication failed`)
      }
    })
    .catch((err: any) => {
      console.log("Keycloak initialization failed", err)
    })
}

KC.onTokenExpired = () => {
  console.log(`${getUsername()} token expired`)
  update()
}

const AuthService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  getParsedToken,
  getUsername,
  getEmail,
  hasRole,
  getLoggedUser,
  hasValidResource
}

export default AuthService
